export const getParameterByName = (nameParam, urlParam) => {
  const url = urlParam || window.location.href;
  const name = nameParam.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?#&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const storeJwt = (jwt) => {
  localStorage.setItem('jwt', jwt);
};

export const getJwt = () => (
  localStorage.getItem('jwt')
);

export const storeToken = (jwt) => {
  localStorage.setItem('token', jwt);
};

export const getToken = () => (
  localStorage.getItem('token')
);

export const unstoreToken = () => {
  localStorage.removeItem('token');
};

export const unstoreJwt = () => {
  localStorage.removeItem('jwt');
};

export const resetarExibirLogotipo = () => {
  if (sessionStorage.getItem('comprevConfigLogotipo')) {
    const logotipoJson = { exibirLogo: 1 };
    window.comprevConfigLogotipo = logotipoJson;
    sessionStorage.setItem('comprevConfigLogotipo', JSON.stringify(logotipoJson));
  }
};

export const logout = () => {
  unstoreJwt();
  unstoreToken();
  resetarExibirLogotipo();
};

export const getAuthorizationHeader = () => (
  getJwt() ? `Bearer ${getJwt()}` : ''
);

export const checkUser = (userData) => {
  if (userData) {
    let userPermissions = null;
    userData.roles.forEach((role) => {
      const isRGPS = role.match(/RGPS/g);
      if (isRGPS) {
        userPermissions = 1;
      }
      const isRPPS = role.match(/RPPS/g);
      if (isRPPS) {
        userPermissions = 2;
      }
    });
    return userPermissions;
  }
  return null;
};

export const checkTokenUsuario = (userData) => {
  let retorno = false;
  if (userData) {
    // ************** CAMPO EXP VINDO DO JWT **************
    const campoExpVindoJWT = (`${userData.exp}000`);
    // ************** CAMPO EXP VINDO DO JWT **************
    // ************** CAMPO EXP NUMERICO     **************
    const expiracaoToken = parseInt(campoExpVindoJWT, 10);
    // ************** CAMPO EXP NUMERICO     **************
    // ************** DATA E HORA ATUAL    **************
    const agoraData = Date.now();
    const agora = parseInt(agoraData, 10);
    // ************** DATA E HORA ATUAL    **************
    // ************** SE A DATA E HORA DO TOKEN FOR MAIOR QUE A DATA/HORA ATUAL,   **************
    // ************** FAZER LOGOUT E DAR UM REFRESH NA TELA                        **************
    if (agora > expiracaoToken) {
      retorno = true;
      return retorno;
    }
  }
  return retorno;
};



// WEBPACK FOOTER //
// ./src/components/ComponentesAutenticacao/utils.js